import {Market} from './market.enum';
import {DealerProduct} from './dealer-product.model';

export class Dealer {
  id: number;
  dealerName: string;
  deliveringAgent = 'BMW Group Belux';
  dealerNumber: string;
  sapDealerNumber: string;
  dealerRegion = 'BE';
  dealerFactor: number;
  buno: string;
  businessPartnerId: string;
  market: Market;
  products: DealerProduct[];
  dealerStreet?: string;
  dealerStreetNumber?: string;
  dealerZipCode?: string;
  dealerCity?: string;
}
